module.exports = __webpack_public_path__ + "static/media/aboutMe.6c8d6b63.png";